import { render, staticRenderFns } from "./IconList.vue?vue&type=template&id=28b13864&scoped=true&"
import script from "./IconList.vue?vue&type=script&lang=js&"
export * from "./IconList.vue?vue&type=script&lang=js&"
import style0 from "./IconList.vue?vue&type=style&index=0&id=28b13864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b13864",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28b13864')) {
      api.createRecord('28b13864', component.options)
    } else {
      api.reload('28b13864', component.options)
    }
    module.hot.accept("./IconList.vue?vue&type=template&id=28b13864&scoped=true&", function () {
      api.rerender('28b13864', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/dev/IconList.vue"
export default component.exports